import type { Resource } from '../../';
export const product_group_youth: Resource = {"default":"Youth"};
